// extracted by mini-css-extract-plugin
export default {"zoom":"Uqa-z","zoomContent":"Vqa-z"};